import * as types from './types'

export default {
  [types.SET_MEMBER_ID](state, id) {
    state.memberId = id
  },
  [types.SET_MEMBER_ROLE](state, role) {
    state.memberRole = role
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/hangfire/mutations.js